import { Input, Tooltip } from 'antd';
import { CopyButton } from './CopyButton';

export interface CopyableInputProps {
  value: string;
  disabled: boolean;
  title?: string;
}

export const CopyableInput = ({
  value,
  disabled,
  title = 'Скопировать',
}: CopyableInputProps) => {
  return (
    <div style={{ display: 'flex' }}>
      <Input value={value} disabled={disabled} />
      <Tooltip title={title}>
        <CopyButton text={value} />
      </Tooltip>
    </div>
  );
};
